import Modal from "./Modal";
import confirm from "./confirm";
import middleware from "../../middleware";

Modal.info = function(props) {
  const config = {
    type: "info",
    iconType: "info-circle",
    okCancel: false,
    showClose: true,
    ...props
  };
  return confirm(config);
};

Modal.success = function(props) {
  const config = {
    type: "success",
    iconType: "check-circle",
    okCancel: false,
    showClose: true,
    ...props
  };
  return confirm(config);
};

Modal.error = function(props) {
  const config = {
    type: "error",
    iconType: "cross-circle",
    okCancel: false,
    showClose: true,
    ...props
  };
  return confirm(config);
};

Modal.warning = Modal.warn = function(props) {
  const config = {
    type: "warning",
    iconType: "exclamation-circle",
    okCancel: false,
    showClose: true,
    ...props
  };
  return confirm(config);
};

Modal.confirm = function(props) {
  const config = {
    type: "confirm",
    ecIconType: "icon-coms-Prompt",
    okCancel: true,
    showClose: true,
    ...props
  };
  return confirm(config);
};

const Com = middleware(Modal, "Modal");
export default Com;



// WEBPACK FOOTER //
// ./_antd1.11.2/modal/index.jsx